import { Banner } from '@sunwebgroup/uds-ui/banner'
import { Button } from '@sunwebgroup/uds-ui/button'
import * as React from 'react'
import { useIntl } from '@/intl'
import { AdditionalCostType, AdditionalCostTypeValues, CheckoutCarAdditionalCost } from '@/scopes/checkout/domain/types'

interface AdditionalCostBannersProps {
  additionalCosts?: Record<string, CheckoutCarAdditionalCost>
  onConditionsButtonClick: () => void
}

function additionalCostTextKeys(key: AdditionalCostType): string | undefined {
  const mapping: Record<string, string> = {
    outOfHour: 'checkout_steps_ancillaries_car_rental_filtering_outside_office_hours_text',
    environmentalFee: 'checkout_steps_ancillaries_car_rental_filtering_environmental_fee_text',
  }
  return mapping[key]
}

export function AdditionalCostBanners({ additionalCosts, onConditionsButtonClick }: AdditionalCostBannersProps) {
  const intl = useIntl()

  if (!additionalCosts)
    return null

  const additionalCostsToRender = Object.entries(additionalCosts).filter(
    ([additionalCostKey, additionalCost]) => additionalCostKey !== AdditionalCostTypeValues.ONE_WAY && additionalCost.aproxFeeAmount > 0,
  )

  if (additionalCostsToRender.length === 0)
    return null

  return (
    <>
      {additionalCostsToRender.map(([additionalCostKey, additionalCost]) => {
        const featureTextKey = additionalCostTextKeys(additionalCostKey as AdditionalCostType) || ''

        const text = featureTextKey ? intl.formatMessage({ id: featureTextKey }, { price: intl.formatCurrency(additionalCost.aproxFeeAmount) }) : `${additionalCost.description} (${intl.formatCurrency(additionalCost.aproxFeeAmount)})`

        return (
          <Banner key={additionalCostKey} color="warning" hasIcon size="S" text="">
            <Banner.ContentWrapper actionsPosition="bottom">
              <Banner.TextsWrapper>
                <Banner.Text>
                  {text}
                </Banner.Text>
              </Banner.TextsWrapper>
              <Banner.ActionsWrapper actionsPosition="bottom">
                <Button variant="secondary" size="XS" onClick={onConditionsButtonClick}>
                  {intl.formatMessage({
                    id: 'checkout_steps_ancillaries_car_rental_filtering_additional_costs_button',
                  })}
                </Button>
              </Banner.ActionsWrapper>
            </Banner.ContentWrapper>
          </Banner>
        )
      })}
    </>
  )
}
